import BaseRequest from './BaseRequest';

const schema = 'admin-notification';
const userSchema = 'notify';

export default class NotificationRequest extends BaseRequest {
  /**
     * key base on host:port
     */

  fetchNotifications(params) {
    const url = `${schema}/paginate-new`;
    return this.get(url, params);
  }

  fetchUserNotifications(params) {
    const url = `${userSchema}/notifies`;
    return this.get(url, params);
  }

  fetchMarkedUserNotifications(params) {
    const url = `${userSchema}/new-notifies`;
    return this.get(url, params);
  }

  checkedNotification(params) {
    const url = `${userSchema}/${params}`;
    return this.put(url);
  }

  checkedAllNotifications(params) {
    const url = `${userSchema}/all`;
    return this.put(url, params);
  }

  deleteNotification(params) {
    const url = `${userSchema}/${params}`;
    return this.del(url);
  }

  deleteAllNotifications(params) {
    const url = `${userSchema}/all`;
    return this.del(url);
  }
}
